import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
import _max from "lodash/max";
import _isEqual from "lodash/isEqual";
var _dec, _dec2, _dec3, _dec4, _dec5, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
import { action, computed, observable, toJS } from 'mobx';
import { Collection } from 'core/model/Collection';
import api from 'core/util/api';
import MetricDeviceModel from './MetricDeviceModel';
const LIMIT = 10000;
let MetricDeviceCollection = (_dec = observable.ref, _dec2 = observable.ref, _dec3 = observable.ref, _dec4 = observable.ref, _dec5 = observable.ref, _class = class MetricDeviceCollection extends Collection {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "serverFilter", _descriptor, this);
    _initializerDefineProperty(this, "memoryUtilQueryData", _descriptor2, this);
    _initializerDefineProperty(this, "cpuUtilQueryData", _descriptor3, this);
    _initializerDefineProperty(this, "temperatureQueryData", _descriptor4, this);
    _initializerDefineProperty(this, "totalCount", _descriptor5, this);
    this.serverSortableFields = ['id', 'status', 'name', 'labels', 'ip_address', 'location', 'site.title', 'sys_object_id', 'system_description', 'vendor', 'model', 'product_name', 'os_name', 'os_version', 'serial_number', 'monitoring_template_id'];
    this.setMemoryUtilQueryData = () => {
      this.memoryUtilQueryData.forEach(result => {
        const device = this.get(result.device_id);
        if (device && device.get('memory_util') !== result.last_memory_util) {
          device.set('memory_util', result.last_memory_util);
        }
        if (device && device.get('memory_util_timeseries') !== result.sparklineData) {
          device.set('memory_util_timeseries', result.sparklineData);
        }
      });
    };
    this.setCpuUtilQueryData = () => {
      this.cpuUtilQueryData.forEach(result => {
        const device = this.get(result.device_id);
        if (device && device.get('cpu_util') !== result['last_total/instant']) {
          device.set('cpu_util', result['last_total/instant']);
        }
        if (device && device.get('cpu_util_timeseries') !== result.sparklineData) {
          device.set('cpu_util_timeseries', result.sparklineData);
        }
      });
    };
    this.setTemperatureQueryData = () => {
      this.temperatureQueryData.forEach(result => {
        const device = this.get(result.device_id);
        if (device) {
          device.set('temperature', {
            avg_instant: result.avg_instant,
            max_instant: result.max_instant,
            last_instant: result.last_instant
          });
        }
        if (device && device.get('temperature_timeseries') !== result.sparklineData) {
          device.set('temperature_timeseries', result.sparklineData);
        }
      });
    };
    _initializerDefineProperty(this, "fetchUpdatedOnly", _descriptor6, this);
  }
  get queuedFetchKey() {
    return this.id;
  }
  get defaultSortState() {
    return {
      field: 'name',
      direction: 'asc'
    };
  }
  get updateInterval() {
    return 3000; // 3s
  }
  get secondarySort() {
    return this.defaultSortState;
  }
  get url() {
    return '/api/ui/recon/devices';
  }
  get fetchMethod() {
    return 'post';
  }
  get model() {
    return MetricDeviceModel;
  }
  clearFilters() {
    this.serverFilter = {
      limit: LIMIT
    };
    super.clearFilters();
    this.queuedFetch();
  }
  async fetch(options = {}) {
    return super.fetch(this.getFetchOptions(options));
  }
  async queuedFetch(options = {}) {
    return super.queuedFetch(this.getFetchOptions(options));
  }
  getFetchOptions(options = {}) {
    const {
      data = {}
    } = options;
    const sortBy = this.getServerSortBy();
    return {
      ...options,
      data: {
        sortBy: sortBy || undefined,
        ...this.getServerFilter(),
        ...data
      }
    };
  }
  getServerFilter() {
    return toJS(this.serverFilter);
  }
  setServerFilter(filter) {
    if (_isEqual(filter, toJS(this.serverFilter))) {
      return Promise.resolve();
    }
    this.serverFilter = {
      ...filter,
      limit: LIMIT
    };
    return this.queuedFetch().then(() => {
      this.setCpuUtilQueryData();
      this.setMemoryUtilQueryData();
    });
  }
  get idToNameMap() {
    const map = {};
    this.models.forEach(model => {
      map[model.id] = model.get('name');
    });
    return map;
  }

  // @ts-expect-error this is an invalid function signature but I do not want to risk changing the implementation right now
  deserialize(data = {}) {
    const {
      models,
      metadata = {}
    } = data;
    if (metadata.totalCount) {
      this.totalCount = metadata.totalCount;
    }
    return super.deserialize(models);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "serverFilter", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {
      limit: LIMIT
    };
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "memoryUtilQueryData", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "cpuUtilQueryData", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "temperatureQueryData", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "totalCount", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _applyDecoratedDescriptor(_class.prototype, "clearFilters", [action], Object.getOwnPropertyDescriptor(_class.prototype, "clearFilters"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setServerFilter", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setServerFilter"), _class.prototype), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "fetchUpdatedOnly", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return () => {
      if (this.requestStatus || !this.lastFetched) {
        // skip when already fetching or hasn't been fetched yet
        return Promise.resolve();
      }
      this.setRequestStatus('fetchingMore');
      const updated = new Date(this.lastFetched).toISOString();
      return api.post('/api/ui/recon/devices', this.getFetchOptions({
        data: {
          updated
        }
      })).then(action(({
        models
      }) => {
        const modelsToAdd = [];
        models.forEach(result => {
          const device = this.get(result.id);
          if (device) {
            // since `Model.replace` doesn't do what we want, iterate over the keys in the result and do it manually
            Object.keys(result).forEach(key => {
              device.set(key, result[key]);
            });
          } else {
            modelsToAdd.push(result);
          }
        });
        if (modelsToAdd.length) {
          this.add(modelsToAdd);
        }

        // wait half a second to set the request status to null so that the loading indicator doesn't flash
        setTimeout(() => {
          this.setRequestStatus(null);
        }, 500);
        const latestEdate = _max(models.map(m => m.edate)) || '';
        this.setLastFetched(Date.parse(latestEdate) + 1 || this.lastFetched || 0);
      }));
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, "idToNameMap", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "idToNameMap"), _class.prototype), _class);
export default MetricDeviceCollection;